/*eslint-disable */
import { useContext, useState, useEffect } from 'react';
import ListHeader from '../SectionHeader';
import TablePagination from '../TablePaginationComponent';
import GlobalContext from '../../contexts/index';
import useSort from '../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../assets/images/sort.svg';
import Filter from '../Filter';
import { useNavigate } from 'react-router-dom';
import globalTranslating from '../../translate.json';
import surveyTestTranslating from './translate.json';
import SnackBar from 'components/SnackBar';
import { useParams } from 'react-router-dom';
import Api from 'utils/api';
import './styles.scss';

const SurveyTest = () => {
  const translating = { ...globalTranslating, ...surveyTestTranslating };
  const { id: surveyMeasuresType } = useParams();
  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const [filteredSurveymeasures, setFilteredSurveymeasures] = useState([]);
  const [surveyLabData, setSurveyLabData] = useState([]);
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    if (surveyLabData?.length) setFilteredSurveymeasures(surveyLabData);
  }, [surveyLabData]);

  useEffect(() => {
    Api.get(`survey-measures/byType/${surveyMeasuresType || 'measures'}`).then(
      (res) => {
        const tmpRes = [...res.data];
        tmpRes.sort((a, b) => a.orderNumber - b.orderNumber);
        setSurveyLabData(tmpRes);
      }
    );
  }, [surveyMeasuresType]);

  const onFilter = (filteredData) => {
    setFilteredSurveymeasures(filteredData);
  };

  const onResetFilters = () => {
    console.log('surveyLabData');
    setFilteredSurveymeasures(surveyLabData);
  };

  const { showFilters, toggle } = useSort();

  const tableHeaders = [
    'id',
    translating.name,
    translating.minValue,
    translating.maxValue,
    translating.minNormalValue,
    translating.maxNormalValue,
    translating.isNumberInput,
    translating.isRequired,
    translating.gender,
    translating.minRedFlagValue,
    translating.maxRedFlagValue,
    translating.tool,
    translating.orderNumber,
    translating.isActive
  ];

  const columns = [
    { value: 'id' },
    { value: 'name', bold: true },
    { value: 'minValue' },
    { value: 'maxValue' },
    { value: 'minNormalValue' },
    { value: 'maxNormalValue' },
    { value: 'isNumeric', format: 'status' },
    { value: 'isRequired', format: 'status' },
    { value: 'gender' },
    { value: 'minRedFlagValue' },
    { value: 'maxRedFlagValue' },
    { value: 'tool' },
    { value: 'orderNumber' },
    { value: 'isActive', format: 'status' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['name']
    }
  ];

  return (
    <div className="survey-measures">
      <ListHeader
        title={translating[surveyMeasuresType]}
        // newItem={{ handleClick: () => setLink('d2') }}
      ></ListHeader>
      {showFilters && (
        <Filter
          fields={sortFields}
          data={filteredSurveymeasures}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="survey-measures-wrapper-table">
        {filteredSurveymeasures && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredSurveymeasures}
            pagination={true}
            handleRowClick={(id) => {
              navigate(`/survey/${surveyMeasuresType || 'measures'}/${id}`);
            }}
          ></TablePagination>
        )}
      </div>
      {/* {showSnackbar && (
                <SnackBar msg={'מדד נוסף'} handleClose={() => setShowSnakbar(false)}></SnackBar>
            )} */}
    </div>
  );
};

export default SurveyTest;
